import React from "react";
import { NavLink as RouterNavLink } from "react-router-dom";

interface SidebarComponentProps {
  isOpen: boolean;
  setIsOpen: () => void;
}

const SidebarComponent: React.FC<SidebarComponentProps> = (
  props: SidebarComponentProps
) => {
  const { isOpen, setIsOpen } = props;
  return (
    <div className="">
      {/* Nút menu (chỉ hiện khi dưới md) */}

      {/* Overlay (màn đen khi mở sidebar) */}
      {isOpen && (
        <div
          className="fixed left-0 top-[80px]  w-full h-[calc(100%-80px)] bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setIsOpen()}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed left-0 h-[calc(100%-80px)] top-[80px] w-[290px] bg-white p-4 border-r z-50 transform transition-transform duration-300
  ${isOpen ? "translate-x-0" : "-translate-x-full"}
  xl:translate-x-0 xl:static xl:block xl:h-screen xl:top-0`}
      >
        {/* Logo */}
        {/* <div className="flex items-center h-20 w-full">
          <div className="flex items-center mb-6 text-2xl font-semibold text-gray-900">
            <img
              className="w-8 h-8 mr-2"
              src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/logo.svg"
              alt="logo"
            />
            <p className="text-gray-800 font-bold text-2xl">BH Travel</p>
          </div>
        </div> */}

        {/* Menu */}
        <p className="text-gray-400 text-xs font-medium">MENU</p>
        <div className="flex flex-col gap-1 mt-3" onClick={setIsOpen}>
          <NavLink name="Chuyến đi" url="trips" icon="fa-suitcase-rolling" />
          <NavLink name="Khách hàng" url="customers" icon="fa-sold fa-person" />
          <NavLink
            name="Lịch vạn niên"
            url="calendars"
            icon="fa-solid fa-calendar"
          />
          <NavLink name="Tài khoản" url="accounts" icon="fa-solid fa-user" />
          <NavLink name="Lịch sử" url="histories" icon="fas fa-history" />
        </div>
      </aside>
    </div>
  );
};

interface INavLinkProps {
  icon?: string;
  name: string;
  url: string;
  // action:()=>void
}

const NavLink: React.FC<INavLinkProps> = ({ icon, name, url }) => {
  return (
    <RouterNavLink
      to={url}
      // onClick={()=>}
      className={({ isActive }) =>
        `flex items-center p-2.5 rounded-md gap-2 transition-colors duration-200 ${
          isActive
            ? "bg-blue-100 font-bold text-blue-600"
            : "hover:bg-gray-100 text-gray-600"
        }`
      }
    >
      <i className={`fa-solid text-base ${icon}`} />
      <span className="text-sm font-medium">{name}</span>
    </RouterNavLink>
  );
};

export default SidebarComponent;
